import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import Button from '../../elements-buttons/Button';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import DateField from '../../app-main/components/reduxForms/fields/DateField/DateField';
import { CSV_DATES_FORM } from './forms/constants';
import onSubmitCsvDateForm from './forms/onSubmitCsvDateForm';
import onChangeDateForm from './forms/onChangeDateForm';
import validateCsvForm from './forms/validateCsvForm';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';

const CsvModal = ({ ...props }) => {
  const { dispatch, toDate, fromDate, handleSubmit, error, intl } = props;

  const translationMessage = defineMessages({
    formPlaceholderFrom: {
      id: 'hosting.csv_modal.modal_form_placeholder_from',
      defaultMessage: 'from date'
    },
    formPlaceholderTo: {
      id: 'hosting.csv_modal.modal_form_placeholder_to',
      defaultMessage: 'to date'
    },
    formErrorMessageFrom: {
      id: 'hosting.csv_modal.modal_form_error_message_from',
      defaultMessage: 'Please enter a from date'
    },
    formErrorMessageTo: {
      id: 'hosting.csv_modal.modal_form_error_message_to',
      defaultMessage: 'Please enter a to date'
    }
  });

  return (
    <BootstrapModal
      {...props}
      header={ <h4><FormattedMessage id="hosting.csv_modal.modal_header" defaultMessage="Download CSV" /></h4> }
      body={
        <div>
          <div className="flex space-betewen">
            <div className="flex-basis-50 margin-md-right">
              <label htmlFor="CsvFromDate"><FormattedMessage id="hosting.csv_modal.modal_form_label_from" defaultMessage="From"/></label>
              <Field
                id="CsvFromDate"
                component={DateField}
                name="from"
                placeholder={intl.formatMessage(translationMessage.formPlaceholderFrom)}
                errorMessage={intl.formatMessage(translationMessage.formErrorMessageFrom)}
                onChange={(e, value) => onChangeDateForm(value, toDate, dispatch)}
                datePickerProps={{
                  disabledDays: [{ after: new Date() }]
                }}
              />
            </div>
            <div className="flex-basis-50 margin-md-left">
              <label htmlFor="CsvToDate"><FormattedMessage id="hosting.csv_modal.modal_form_label_to" defaultMessage="to"/></label>
              <div>
                <Field
                  id="CsvToDate"
                  component={DateField}
                  name="to"
                  placeholder={intl.formatMessage(translationMessage.formPlaceholderTo)}
                  errorMessage={intl.formatMessage(translationMessage.formErrorMessageTo)}
                  datePickerProps={{
                    fromMonth: fromDate,
                    disabledDays: [{ before: fromDate, after: new Date() }]
                  }}
                />
              </div>
            </div>
          </div>
          { error && <div className="text-danger margin-lg-top">{error}</div> }
        </div>
      }
      modalSize="sm-size"
      modalClass="CsvModal"
      footer={
        <Button
          buttonClassname="text-center"
          category="primary"
          onClick={handleSubmit(onSubmitCsvDateForm)}
          attributes={{ 'data-testing-id': 'download-csv' }}
          isLoading={get(props, 'payouts.csvFetching')}
          className="btn-outlined-light"
        >
          <FormattedMessage id="hosting.csv_modal.modal_form_button_text" defaultMessage="Download"/>
        </Button>
      }
    />
  );
};

CsvModal.propTypes = {
  cancelAction: PropTypes.func,
  bodyText: PropTypes.string,
  dispatch: PropTypes.func,
  toDate: PropTypes.string,
  fromDate: PropTypes.string,
  handleSubmit: PropTypes.string,
  error: PropTypes.string,
  csvFetching: PropTypes.bool,
  intl: intlShape
};

const selector = formValueSelector(CSV_DATES_FORM);
const mapStateToProps = (state) => {
  const fromDate = selector(state, 'from');
  const toDate = selector(state, 'to');

  return {
    auth: state.auth,
    profile: state.profile,
    fromDate,
    toDate,
    payouts: state.payouts
  };
};

const config = {
  form: CSV_DATES_FORM,
  validate: validateCsvForm
};

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(CsvModal)));
